import Vue from 'vue'
import Vuex from 'vuex'

import globalstate from './modules/globalstate'
import messages from './modules/messages'
import api from './modules/api'
import auth from './modules/auth'
import locale from './modules/locale'
import keyboard from './modules/keyboard'
import config from './modules/config'
import ping from './modules/ping'
import address from './modules/address'
import menu from './modules/menu'
import order from './modules/order'
import orders from './modules/orders'
import event from './modules/event'
import guests from './modules/guests'
import cashReport from './modules/orders/cashReport'
import deliveryZonesReport from './modules/orders/deliveryZonesReport'
import guestshReport from './modules/orders/guestsReport'
import remoteOrdersReport from './modules/orders/remoteOrdersReport'
import dayPictureReport from './modules/orders/dayPicture'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
    async initApplication({dispatch, getters}) {
      const $t = getters.localePhrase
      
      try {
        await dispatch('setGlobalLoading', $t('Загрузка конфигурации...')) 
        await dispatch('loadConfig')
      } finally {
        dispatch('setGlobalLoading')
      }
    }
  },
  getters: {
    url() {
      return process.env.NODE_ENV == 'development' ? 'http://127.0.0.1:11222' : ''
    }
  },
  modules: {
    globalstate,
    messages,
    api,
    auth,
    locale,
    keyboard,
    config,
    ping,
    address,
    menu,
    order,
    orders,
    event,
    guests,
    cashReport,
    deliveryZonesReport,
    guestshReport,
    remoteOrdersReport,
    dayPictureReport,
  }
})
